import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}nong-tung-jai`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const nongtungjaiApi = {
  getPatientList: (request) => {
    const { config } = request
    return instance().get('/member-list', config)
  },
  getPatientDetails: (request, member_id) => {
    const { config } = request
    return instance().get(`/subretroact-list/${member_id}`, config)
  },
  getCurrentRetroactWithSubretroact: (request, member_id) => {
    const { config } = request
    return instance().get(`/current-retroact-with-subretroact/${member_id}`, config)
  },
  getSummary3Months: (request, member_id) => {
    const { config } = request
    return instance().get(`/analyze-3-months/${member_id}`, config)
  },
  getAssessment3Months: (request) => {
    const { config, memberId } = request
    return instance().get(`/assessment-form-3-month/${memberId}`, config)
  },
  getSelfReferral: (request) => {
    const { params } = request
    return instance().get(`/therapy`, {
      params
    })
  },
  patchUpdateSelfReferral: (request) => {
    const { data, id } = request
    return instance().patch(`/therapy/${id}`, data)
  },
  deleteSelfReferral: (request) => {
    const { id, pageId } = request
    return instance().delete(`/therapy/${id}`, {
      params: {
        page_id: pageId
      }
    })
  }
}
export default nongtungjaiApi



// WEBPACK FOOTER //
// ./src/api/nongtungjai.js